import { useContext, useState } from "react";
// eslint-disable-next-line import/named
import { FieldValues, useForm } from "react-hook-form";
import { useImmer } from "use-immer";
import { trans } from "@/service/i18n/i18n";
import { model } from "./model";
import { preSubmit } from "@/forms/validation";
import { handleUserError } from "@/service/client-api/error-handler";
import { Button } from "@/components/ui/button";
import { UserContext } from "@/contexts/user-context";
import { clientGet, clientPatch } from "@/service/client-api/client-api";
import { ResourceContext } from "@/contexts/resource-context";
import { logPermissionEvent } from "@/components/common/permission/service";
import { vestResolver } from "@hookform/resolvers/vest";
import { fromFormDefinitionToValidationSchema } from "@/forms/validation/validation-factory";
import { CheckboxField } from "@/forms/fields/checkbox-field/checkbox-field";
import { Form } from "@/components/ui/form";
import { LoaderIcon } from "lucide-react";
import { FormError } from "@/forms/form-error";

export const SignOnNewsletter = ({
  redirectTo,
  resourceType,
}: {
  redirectTo?: string;
  resourceType: string;
}) => {
  const [fields, setFields] = useImmer(model);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { logView } = useContext(ResourceContext);

  const user = useContext(UserContext);

  const form = useForm({
    resolver: vestResolver(fromFormDefinitionToValidationSchema(fields)),
  });
  const { handleSubmit } = form;

  const onSubmit = async ({ newsletter }: FieldValues) => {
    if (preSubmit(loading, setLoading, setError, setFields) === "BREAK") {
      return;
    }

    const oldSnapshot = (await clientGet("profile.info")) as any;

    try {
      await clientPatch("profile.update", {}, { newsletter });

      await logPermissionEvent("save_to_newsletter", logView, oldSnapshot);

      if (redirectTo) {
        window.location.href = redirectTo;
      } else {
        window.location.reload();
      }
    } catch (caughtError) {
      setLoading(false);
      handleUserError(caughtError, setError, setFields);
    }
  };

  return (
    <Form {...form}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <h2
          className={`text-card-foreground mb-6 text-center text-2xl font-semibold`}
        >
          {trans("hello")} {user.shortName},
        </h2>
        <p className={`text-foreground mb-6 text-center text-base font-normal`}>
          {trans("permissions.newsletter")}
        </p>

        <CheckboxField field={fields.newsletter} />

        <Button type="submit" className={"mb-4 w-full"}>
          {loading && <LoaderIcon className={"animate-spin"} size={16} />}{" "}
          {trans("next")}
        </Button>

        <FormError error={error} />
      </form>
    </Form>
  );
};
